<template>
  <!-- If icon text is not replaced -->
  <span ref="hoverIcon" id="hoverIcon" v-if="!checkIconText" :class="{'clickable' : clickable}" class="icon--hover" aria-hidden="true" @mouseenter="e => mouseMoveXY(e.clientX, e.clientY)" @click="onClickCopy(text)">
    <span class="fa icon-color icon-background-color" :class="[{'strong' : strong}, iconClass || 'fa-info-circle']" :style="returnIconCSS"></span>
  <div class="icon--tooltip" :style="displayFixed ? returnToolTipPosition : ''"
        :class="{
        'tooltip-top' : top,
        'tooltip-bottom' : bottom,
        'tooltip-right' : right,
        'tooltip-left' : left,
        'strong' : strong
      }"
      >
      <i class="text-width" v-html="renderedText" />
    </div>
  </span>
  <!-- If icon text is replaced -->
  <span ref="hoverIcon" v-else id="hoverIcon" class="icon--hover" aria-hidden="true" @mouseenter="e => mouseMoveXY(e.clientX, e.clientY)">
    <span class="background-thing icon-color icon-background-color py-1 px-2" :class="{'strong' : strong}" :style="returnIconCSS">{{ iconText }}</span>
    <div class="icon--tooltip"
        :class="{
        'tooltip-top' : top,
        'tooltip-bottom' : bottom,
        'tooltip-right' : right,
        'tooltip-left' : left
        }"
      >
      <div v-html="renderedText" />
    </div>
  </span>
</template>

<script>
export default {
  name: 'hoverToolTip',

  props: {
    text: String,
    top: Boolean,
    bottom: Boolean,
    right: Boolean,
    left: Boolean,
    strong: Boolean,
    iconText: [String, Boolean, Number],
    iconColor: String,
    iconClass: String,
    iconBackgroundColor: {
      type: String
    },
    clickable: Boolean,
    displayFixed: Boolean
  },
  data () {
    return {
      isFeedbackPlay: false,
      mouseX: 270,
      mouseY: 550
    }
  },

  methods: {
    /** Get the X and Y coordinates of the mouse to position the tooltip window next to it (This is used because the
     * survey window can sometimes appear out of the Table bounds and cause clipping) */
    mouseMoveXY (x, y) {
      if (!this.displayFixed) return
      this.mouseX = x
      this.mouseY = y
    },

    /** Copy the content of a tooltip to the clipboard if allowed in the props options */
    onClickCopy () {
      if (!this.clickable) return
      let fakeText = this.text

      fakeText = this.trimSpaces(fakeText)
      fakeText = this.trimSpecialChars(fakeText)
      navigator.clipboard.writeText(fakeText)
      this.playFeedback()
    },

    /** After calling @function onClickCopy - Show a feedback tooltip and then switch back after a delay */
    playFeedback () {
      this.isFeedbackPlay = true

      setTimeout(() => {
        this.isFeedbackPlay = false
      }, 1000)
    },

    /** Remove unecessary spaces */
    trimSpaces (text) {
      if (!text) return

      text = text.replace(/ {2}/g, '')
      text = text.trim()

      return text
    },

    /** Remove unecessary characters */
    trimSpecialChars (text) {
      // text = text.replace(/<strong>/g, '')
      // text = text.replace(/<\/strong>/g, '')
      // text = text.replace(/<br>/g, '')
      text = text.replace(/<.*>/g, '')

      return text
    }
  },

  computed: {
    checkIconText () {
      if (this.iconText === false || this.iconText === '' || typeof this.iconText === 'undefined') return false
      else return true
    },

    renderedText () {
      if (this.isFeedbackPlay) return this.$t('hoverToolTip.copied')
      else return this.trimSpaces(this.text)
    },

    returnIconCSS () {
      return {
        '--icon-color': this.iconColor,
        '--icon-background-color': this.iconBackgroundColor
      }
    },
    returnToolTipPosition () {
      return {
        'position': 'fixed',
        'top': (this.mouseY) + 'px',
        'left': (this.mouseX) + 'px'
      }
    }
  }

}
</script>

<style scoped>
  button {
    border: none;
    border-radius: 0px;
  }

  .clickable {
    cursor: pointer !important;
  }

  .icon--hover {
    color: #f7941e;
    position: relative;
    text-align: center;
  }

  .icon--hover .icon--tooltip {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 0.8rem;
    background: #e88b1a;
    border-radius: 3px;
    color: white;
    margin-bottom: 10px;
    opacity: 0;
    padding: 8px;
    pointer-events: none;
    width: relative;
    -webkit-transform: translateY(10px);
    -moz-transform: translateY(10px);
    -ms-transform: translateY(10px);
    -o-transform: translateY(10px);
    transform: translateY(10px);
    -webkit-transition: all .25s ease-out;
    -moz-transition: all .25s ease-out;
    -ms-transition: all .25s ease-out;
    -o-transition: all .25s ease-out;
    transition: all .25s ease-out;
    -webkit-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -moz-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -ms-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    -o-box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.28);
  }
  .icon--tooltip {
    position: absolute;
    max-width: auto;
    min-width: 275px;
    z-index: 999999;
  }
  .tooltip-top {
    bottom: 40%;
  }

  .tooltip-bottom {
    top: 80%;
  }
  .tooltip-left {
    right: 80%;
  }

  .tooltip-right {
    left: 80%;
  }

  .strong {
    font-weight: 900;
  }
  .icon--hover:hover .icon--tooltip {
    opacity: 1;
    pointer-events: auto;
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  .background-thing {
    font-size: 0.8rem;
    background-color: rgb(255, 255, 255);
    border-radius: 5rem;
    padding: 0.25rem 0.25rem 0.25rem 0.25rem;
  }

  .icon-color {
    color: var(--icon-color);
  }

  .icon-background-color {
    background-color: var(--icon-background-color)
  }
</style>
